import axios from "axios";

export const getSection6 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/about-page-s6-collaboration?populate=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);

  // return {
  //   data: {
  //     "id": 3,
  //     "documentId": "q2o8zspi83mn5dfqpbda0pd5",
  //     "createdAt": "2025-11-30T09:00:39.602Z",
  //     "updatedAt": "2025-12-01T07:42:23.790Z",
  //     "publishedAt": "2025-12-01T07:42:23.851Z",
  //     "TotalCountries": 3,
  //     "TotalPartners": 33,
  //     "Collaborations": [
  //       {
  //         "id": 7,
  //         "Country": "USA",
  //         "Continent": "North America"
  //       },
  //       {
  //         "id": 8,
  //         "Country": "Canada",
  //         "Continent": "North America"
  //       },
  //       {
  //         "id": 9,
  //         "Country": "India",
  //         "Continent": "Asia"
  //       },
  //       {
  //         "id": 10,
  //         "Country": "China",
  //         "Continent": "Asia"
  //       }
  //     ]
  //   },
  //   "meta": {}
  // };
};
